module.exports = __webpack_public_path__ + "img/gigabites.1552741f.svg";